import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dog_breeds = (params: StepConfigParams) => {
  return [
    {
      type: 'dropDown',
      styleType: 'underlined',
      name: 'breeds.0.breed',
      label: {
        type: 'translatableText',
        translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_list.breeds.breed_one',
      },
      condition: {
        type: 'conditions',
        comparisonType: 'anyOf',
        conditions: [
          { type: 'value', valuePath: 'breed_type', expectedValue: 'pedigree' },
          { type: 'value', valuePath: 'breed_type', expectedValue: 'crossbreed' },
        ],
      },
      options: params.helperFunctions.getTransientPath('breeds'),
    },
    {
      type: 'dropDown',
      styleType: 'underlined',
      name: 'breeds.1.breed',
      label: {
        type: 'translatableText',
        translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_list.breeds.breed_two',
      },
      condition: {
        type: 'value',
        valuePath: 'breed_type',
        expectedValue: 'crossbreed',
      },

      options: params.helperFunctions.getTransientPath('breeds'),
    },
  ] as const satisfies AnyStepConfiguration['stepContent']
}

export default dog_breeds
